import React from "react";

const HeroHeader = ({
  variant = "main",
  roundedText = "PEER-TO-PEER GAMING",
  icon: Icon,
  image,
  title,
  subtitle,
}) => {
  const getTitleSize = () => {
    if (variant === "main") {
      return "text-5xl sm:text-6xl md:text-7xl lg:text-8xl mb-4 sm:mb-6 md:mb-8 mt-4 sm:mt-5 md:mt-6";
    }
    return "text-4xl sm:text-5xl md:text-6xl mb-2 sm:mb-3 md:mb-4 mt-2 sm:mt-2.5 md:mt-3";
  };

  const getSubtitleSize = () => {
    return variant === "main"
      ? "text-lg sm:text-xl md:text-xl"
      : "text-base sm:text-lg md:text-lg";
  };

  return (
    <div className="flex flex-col items-center justify-center w-full px-4 sm:px-6 md:px-8">
      {variant !== "image" ? (
        <div className="relative mb-3 sm:mb-4 animate-fade-in-up">
          <div
            className="px-3 py-1.5 rounded-full border text-xs font-semibold tracking-widest uppercase"
            style={{
              background: "rgba(25, 224, 148, 0.12)",
              borderColor: "rgba(25, 224, 148, 0.3)",
              color: "#19E094",
              letterSpacing: "0.06em",
            }}
          >
            <div className="flex items-center gap-1.5 sm:gap-2">
              {Icon && <Icon className="w-3 h-3 sm:w-4 sm:h-4" />}
              <span>{roundedText}</span>
            </div>
          </div>
        </div>
      ) : (
        <img
          src={image || "/api/placeholder/100/40"}
          alt="Header image"
          className="h-48 sm:h-64 md:h-80 w-auto animate-fade-in-up"
          style={{ borderRadius: "20px" }}
        />
      )}
      <h1
        className={`${getTitleSize()} font-extrabold text-center text-p-text-primary leading-tight max-w-4xl mx-auto animate-fade-in-up-delay-1`}
        style={{ letterSpacing: "-0.02em" }}
      >
        {title}
      </h1>
      <p
        className={`${getSubtitleSize()} text-center text-p-text-secondary max-w-xl sm:max-w-2xl mx-auto px-4 leading-relaxed animate-fade-in-up-delay-2`}
        style={{ marginTop: "12px" }}
      >
        {subtitle}
      </p>
    </div>
  );
};

export default HeroHeader;
